import SharePointConfiguration from '../components/SharePointConfiguration';

const QaDocumentSharePoint = () => {
  return (
    <SharePointConfiguration
      title="QA Documents SharePoint"
      pageTitle="QA Documents SharePoint"
      apiUrl="/v0/qa_documents/sharepoint_configuration"
      typesKey="qa_document_types"
      redirectPath="/qa_documents"
      adminRole="qa_documents_admin"
      readRole="qa_documents_readonly"
      contentTypeName="QA Document"
      contentTypeNamePlural="QA Documents"
      defaultLocationHelpText="All QA documents will be uploaded to this location, unless otherwise defined by document type below."
      noTypesMessage="No QA document types defined. (You can define QA document types in CADM)."
    />
  );
};

export default QaDocumentSharePoint;
